<!-- KPIs -->
<div class="po-row">
  <div class="po-sm-12 po-md-3 po-mt-3">
    <span class="kpi-title">Issues Abertas (Por Premissa)</span>
  </div>
</div>
<div class="po-row">
  <div class="po-sm-12 po-md-3 po-mt-3 po-mb-3">
      <po-info
          p-label="Release atual"
          [p-value]="releaseName || '—'"
      ></po-info>
  </div>
</div>

<div class="po-row po-mb-1">
  <div class="po-sm-12 po-md-4 po-lg-4 widget-resolve">
    <po-widget p-title="Zerar">
      <span class="kpi-value">{{ totalResolve }}</span>
    </po-widget>
  </div>

  <div class="po-sm-12 po-md-4 po-lg-4 widget-resolve_or_reduce">
    <po-widget p-title="Zerar ou ao menos reduzir">
      <span class="kpi-value">{{ totalResolveOrReduce }}</span>
    </po-widget>
  </div>

  <div class="po-sm-12 po-md-4 po-lg-4 widget-total">
    <po-widget p-title="Total Issues">
      <span class="kpi-value">{{ totalIssues }}</span>
    </po-widget>
  </div>
  
  <div class="po-row">
    <div class="po-sm-12">
      <po-info
        p-label="Data de referência dos KPIs"
        [p-value]="kpiLastUpdated || '—'"
      ></po-info>
    </div>
  </div>
</div>

<po-divider></po-divider>

<!-- Gráfico: Evolução Diária -->
<div class="po-sm-12 po-md-3 po-mb-3">
  <span class="kpi-title">Evolução de Issues (Release Atual)</span>
</div>
<div class="po-row">
  <div class="po-sm-12">
    <div class="chart-toolbar po-row po-mb-2">
      <po-datepicker-range
        class="po-sm-12 po-md-4 po-lg-3"
        name="dailyPeriod"
        p-label="Período"
        [(ngModel)]="dailyPeriod"
        (p-change)="onDailyPeriodChange()"
      ></po-datepicker-range>

      <po-select
        class="po-sm-12 po-md-3 po-lg-2"
        name="lineChartType"
        p-label="Tipo de gráfico"
        [(ngModel)]="lineChartType"
        [p-options]="chartOptionsDailyEvolution"
      ></po-select>

      <div class="po-sm-12 po-md-5 po-lg-7 chart-actions">
        <po-button
          p-label="PNG"
          p-kind="secondary"
          p-icon="po-icon-download"
          [p-loading]="downloadingLineChart"
          [p-disabled]="!hasLineChartData"
          (p-click)="downloadLineChartAsPng()"
        ></po-button>
      </div>
    </div>

    <div id="dashboard-line-chart">
      <po-chart
        *ngIf="showLineChart"
        [p-type]="lineChartType"
        [p-series]="lineChartDisplaySeries"
        [p-categories]="lineChartDisplayCategories"
        [p-height]="350"
      ></po-chart>
    </div>
  </div>
</div>
